import React from 'react';
import { useParams } from 'react-router-dom';
import Analytics from './Analytics';

const AnalyticsCaseStudyRoute: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  return <Analytics slug={slug} />;
};

export default AnalyticsCaseStudyRoute;
